// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const cpf: CountryValidator<"CR"> = createValidator(
  "cr.cpf",
  39,
);

export default cpf;
export const compact = cpf.compact;
export const format = cpf.format;
export const validate = cpf.validate;
export const generate = (): string =>
  cpf.generate?.() ??
  (() => {
    throw new Error(
      "Validator cr.cpf cannot generate values",
    );
  })();
